<template>
  <div>
    <div v-if="!isUpload">
      <v-card flat :loading="loadLaudo" v-if="status != 'L'">
        <v-card-actions>
          <v-btn color="red" text @click="voltar()">
            <v-icon left color="red">keyboard_return</v-icon> VOLTAR
          </v-btn>
          <v-spacer />

          <!-- Autocomplete de modelos -->
          <v-col cols="12" sm="6" md="5" lg="4" class="pr-2">
            <v-autocomplete
              v-model="modelo"
              :items="modelos"
              :loading="isLoading"
              dense
              outlined
              hide-no-data
              hide-selected
              item-text="nome"
              item-value="_id"
              label="Buscar Modelos"
              placeholder="Digite para buscar"
              prepend-icon="mdi-database-search"
              return-object
              hide-details
              @change="aplicarModelo"
            ></v-autocomplete>
          </v-col>

          <v-col cols="auto" class="d-flex">
            <v-btn color="red accent-1" icon small @click="clear">
              <v-icon>mdi-broom</v-icon>
            </v-btn>

            <v-btn :disabled="content.length < 8" v-if="!idMedelo" icon small color="blue darken-1"
              @click="dialogNovoModelo = true">
              <v-icon>mdi-note-plus</v-icon>
            </v-btn>

            <v-btn v-else icon small :disabled="content.length < 8" color="teal darken-2"
              @click="dialogEditarModelo = true">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-card-actions>

        <v-sheet min-height="60vh" rounded="lg">
          <div class="pa-1">
            <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição …" />
          </div>
        </v-sheet>

        <v-divider />

        <v-card-actions>
          <v-btn :loading="loadSave" disabled color="primary">
            <v-icon left>mdi-pencil</v-icon> assinar digitalmente
          </v-btn>
          <v-btn disabled text color="blue" @click="isUpload = true">
            <v-icon large left>drive_folder_upload</v-icon>anexos
          </v-btn>
          <v-spacer />
          <v-switch
            color="green"
            v-model="status"
            label="LIBERAR"
            true-value="LX"
            false-value="X"
          ></v-switch>
          <v-btn class="ml-2" text readonly :loading="loadSave" :disabled="content.length < 8"
            @click="idLaudo == null ? salvarLaudo() : editarLaudo()" color="blue">
            <v-icon large right>{{ idLaudo != null ? 'save_as' : 'save' }}</v-icon>
            salvar
          </v-btn>
        </v-card-actions>

        <v-alert dense v-show="alert.visible" :type="alert.type">
          {{ alert.message }}
        </v-alert>
      </v-card>

      <v-card v-else flat :loading="loadLaudo">
        <v-card-actions>
          <v-btn :disabled="idExamesOs == null && content.length > 7" color="red" text @click="voltar()">
            <v-icon left color="red">keyboard_return</v-icon> VOLTAR
          </v-btn>
        </v-card-actions>
        <v-divider />
        <v-card-text>
          <div v-html="content"></div>
        </v-card-text>
      </v-card>

      <!-- Diálogo de confirmação de liberação -->
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Alerta de liberação
          </v-card-title>

          <v-card-text>
            Atenção: Após a liberação do laudo, não será possível realizar alterações.
            Certifique-se de revisar todas as informações antes de concluir o processo. Deseja prosseguir?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialog = false">
              Voltar
            </v-btn>
            <v-btn color="blue" text @click="idLaudo == null ? salvarLaudo() : editarLaudo()">
              <v-icon left>save</v-icon>
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <uploadLaudo
      @voltar="isUpload = false"
      v-if="isUpload"
      :ficha="{ idPaciente: paciente.idPaciente, idOrdemServico: paciente.idOrdemServico }"
      :consulta="consulta"
    ></uploadLaudo>

    <!-- Diálogo para novo modelo -->
    <v-dialog v-model="dialogNovoModelo" width="900" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text primary py-4">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Cadastrar novo modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field
            label="Título"
            outlined
            v-model="tituloModelo"
            :rules="[v => !!v || 'Título é obrigatório']"
          ></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-show="!isImprime" v-model="contentModelo" :card-props="{ flat: true }"
              :extensions="extensions" placeholder="Descrição …" />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="fecharDialogoNovoModelo" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            dark
            :loading="loadModelos"
            @click="cadastrarModeloLaudo"
            class="px-4"
            depressed
            :disabled="!tituloModelo || !contentModelo"
          >
            <v-icon left>mdi-content-save</v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar modelo -->
    <v-dialog v-model="dialogEditarModelo" width="800" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text teal darken-2 py-4">
          <v-icon left color="white">mdi-pencil-circle</v-icon>
          Editar modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field
            label="Título"
            outlined
            v-model="tituloModelo"
            :rules="[v => !!v || 'Título é obrigatório']"
          ></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-show="!isImprime" v-model="contentModelo" :card-props="{ flat: true }"
              :extensions="extensions" placeholder="Descrição …" />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="fecharDialogoEditarModelo" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            dark
            @click="atualizarModeloLaudo"
            class="px-4"
            depressed
            :disabled="!tituloModelo || !contentModelo"
          >
            <v-icon left>mdi-content-save-edit</v-icon>
            Salvar alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import { EventBus } from '../../main'
import uploadLaudo from '../medico/uploadLaudo.vue'
import 'tiptap-vuetify/dist/main.css'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

export default {
  name: 'Editor',
  components: { TiptapVuetify, uploadLaudo },
  props: {
    paciente: Object,
    consulta: Object,
    userAux: Object
  },
  data: () => ({
    isImprime: false,
    loadCadastro: false,
    dialogNovoModelo: false,
    dialogEditarModelo: false,
    idLaudo: null,
    loadLaudo: false,
    content: '',
    contentModelo: '', // Conteúdo separado para edição de modelos
    isUpload: false,
    modelo: null,
    dialog: false,
    idExamesOs: null,
    isLoading: false,
    modelos: [],
    loadSave: false,
    loadModelos: false,
    status: 'X',
    alert: { visible: false, message: '', type: 'info' },
    tituloModelo: '', // Variável para título do modelo
    idMedelo: null, // ID do modelo sendo editado
    user: {}, // Dados do usuário logado

    extensions: [
      History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
      [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
    ],
    debounceTimeout: null
  }),

  mounted () {
    this.user = this.$store.getters.usuario || this.userAux

    this.carregarModelos()
    this.buscarLaudoClinicoPorIdExamesOS()
  },

  methods: {
    aplicarModelo () {
      if (this.modelo) {
        this.content = this.modelo.descricao
        this.tituloModelo = this.modelo.nome || this.modelo.titulo
        this.idMedelo = this.modelo._id
      }
    },

    clear () {
      this.content = ''
      this.modelo = null
      this.tituloModelo = ''
      this.idMedelo = null
    },

    async carregarModelos () {
      this.isLoading = true
      try {
        const [modelosLaudo, modelosProntuario] = await Promise.all([
          this.buscarModeloLaudo(),
          this.listarModelosProntuario()
        ])
        const merged = []
        if (modelosLaudo) merged.push(...modelosLaudo)
        if (modelosProntuario) merged.push(...modelosProntuario)
        this.modelos = merged
      } catch (error) {
        console.error('Erro ao carregar modelos:', error)
        this.showAlert('Erro ao carregar modelos', 'error')
      } finally {
        this.isLoading = false
      }
    },

    buscarModeloLaudo () {
      return medicoService.medico.buscarModeloLaudo(this.user.id)
        .then(response => {
          if (response.status === 200 && response.data) {
            return response.data.modelos || response.data
          }
          return []
        })
        .catch(error => {
          console.error('Erro ao buscar modelos de laudo:', error)
          return []
        })
    },

    cadastrarModeloLaudo () {
      if (!this.tituloModelo.trim()) {
        this.showAlert('Título do modelo é obrigatório', 'error')
        return
      }

      this.loadModelos = true
      const modeloData = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.contentModelo || this.content,
        tipo: 'LAUDO'
      }

      medicoService.medico.cadastrarModeloLaudo(modeloData)
        .then(response => {
          if (response.status === 200) {
            this.showAlert('Modelo cadastrado com sucesso!', 'success')
            this.fecharDialogoNovoModelo()
            this.carregarModelos()
          }
        })
        .catch(error => {
          console.error('Erro ao cadastrar modelo:', error)
          this.showAlert('Erro ao cadastrar modelo', 'error')
        })
        .finally(() => {
          this.loadModelos = false
        })
    },

    atualizarModeloLaudo () {
      if (!this.tituloModelo.trim() || !this.idMedelo) {
        this.showAlert('Dados incompletos para atualização', 'error')
        return
      }

      this.loadModelos = true
      const modeloData = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.contentModelo || this.content,
        _id: this.idMedelo
      }

      medicoService.medico.cadastrarModeloLaudo(modeloData)
        .then(response => {
          if (response.status === 200) {
            this.showAlert('Modelo atualizado com sucesso!', 'success')
            this.fecharDialogoEditarModelo()
            this.carregarModelos()
          }
        })
        .catch(error => {
          console.error('Erro ao atualizar modelo:', error)
          this.showAlert('Erro ao atualizar modelo', 'error')
        })
        .finally(() => {
          this.loadModelos = false
        })
    },

    fecharDialogoNovoModelo () {
      this.dialogNovoModelo = false
      this.tituloModelo = ''
      this.contentModelo = ''
    },

    fecharDialogoEditarModelo () {
      this.dialogEditarModelo = false
      this.tituloModelo = ''
      this.contentModelo = ''
      this.idMedelo = null
    },

    buscarLaudoClinicoPorIdExamesOS () {
      if (!this.consulta) return
      const idExameOS = this.consulta.idexamesos || this.consulta.idExamesOS

      if (!idExameOS) {
        console.error('ID do exame não encontrado na consulta:', this.consulta)
        this.showAlert('ID do exame não encontrado para carregar o laudo', 'error')
        return
      }

      this.loadLaudo = true
      medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExameOS, this.paciente && this.paciente.idPaciente)
        .then(response => {
          if (response.status === 200 && response.data) {
            this.idExamesOs = response.data.idExamesOS
            this.content = response.data.descricaoLaudo || ''
            this.status = response.data.status || 'X'
            this.idLaudo = response.data.id
          }
        })
        .catch(error => {
          console.error('Erro ao buscar laudo:', error)
          this.showAlert('Erro ao carregar laudo', 'error')
        })
        .finally(() => {
          this.loadLaudo = false
        })
    },

    editarLaudo () {
      this.dialog = false
      this.loadSave = true

      medicoService.medico.editarLaudoClinico(
        this.idLaudo,
        this.content,
        this.status === 'LX' ? 'L' : 'X'
      )
        .then(response => {
          if (response.status === 200) {
            this.showAlert('Laudo editado com sucesso!', 'success', 3000, () => this.voltar())
          }
        })
        .catch(error => {
          console.error('Erro ao editar laudo:', error)
          this.showAlert('Erro ao editar laudo', 'error')
        })
        .finally(() => {
          EventBus.$emit('reloadQuantidadeLaudosTec')
          this.loadSave = false
        })
    },

    salvarLaudo () {
      this.dialog = false
      this.loadSave = true
      const idExameOS = this.consulta.idexamesos || this.consulta.idExamesOS

      medicoService.medico.cadastrarLaudoClinico({
        idExamesOs: idExameOS,
        idPaciente: this.paciente.idPaciente,
        idEmpresa: this.user.idEmpresa,
        idUnidade: this.user.idUnidade,
        idPrestador: null,
        idUsuario: this.user.id,
        descricao: this.content,
        status: this.status === 'LX' ? 'L' : 'X'
      })
        .then(response => {
          if (response.status === 200) {
            this.idLaudo = response.data.id
            this.showAlert('Laudo cadastrado com sucesso!', 'success', 3000, () => this.voltar())
          }
        })
        .catch(error => {
          console.error('Erro ao salvar laudo:', error)
          this.showAlert('Erro ao salvar laudo', 'error')
        })
        .finally(() => {
          this.loadSave = false
        })
    },

    showAlert (message, type, timeout = 3000, callback) {
      this.alert = { visible: true, message, type }
      setTimeout(() => {
        this.alert.visible = false
        if (callback) callback()
      }, timeout)
    },

    listarModelosProntuario () {
      const idExame = this.consulta && this.consulta.idExame
      if (!this.user.id) return Promise.resolve([])
      return medicoService.medico.listarModelosProntuario('LAUDO', this.user.id, idExame)
        .then(({ status, data }) => {
          if (status === 200 && data && data.status !== 'error') {
            return Array.isArray(data) ? data : []
          }
          return []
        })
        .catch(error => {
          console.error('Erro ao listar modelos de prontuário:', error)
          return []
        })
    },

    voltar () {
      this.$emit('voltar', true)
    }
  },

  watch: {
    status (val) {
      if (val === 'LX') {
        this.dialog = true
      }
    },

    dialogNovoModelo: {
      handler (val) {
        if (val) {
          // Ao abrir o diálogo, copiar o conteúdo atual para edição
          this.contentModelo = this.content
          this.tituloModelo = ''
        }
      },
      immediate: false
    },

    dialogEditarModelo: {
      handler (val) {
        if (val && this.modelo) {
          // Ao abrir o diálogo de edição, copiar os dados do modelo selecionado
          this.contentModelo = this.modelo.descricao
          this.tituloModelo = this.modelo.nome
        }
      },
      immediate: false
    }
  }
}
</script>
